import { getApiUrl } from '@/api/apiClient.js';

const BASE = '/api/agencies';
const BASE_MISSION_CONTROL = '/api/mission_control/agencies';

export default {
  getAll: () => getApiUrl(`${BASE}`),
  getById: (id) => getApiUrl(`${BASE}/${id}`),
  getUsersByAgencyId: (id) => getApiUrl(`${BASE}/${id}/users`),
  getAgencyIdentifiers: (id) => getApiUrl(`${BASE}/${id}/identifiers`),
  createAgencyUser: () => getApiUrl(`${BASE_MISSION_CONTROL}/users`),
  createAgency: () => getApiUrl(`${BASE_MISSION_CONTROL}`),
  createAgencyUserResetLink: () => getApiUrl(`${BASE_MISSION_CONTROL}/users/password_ticket`),
  sendInvitationEmail: ({ id, user_id }) => getApiUrl(`${BASE_MISSION_CONTROL}/${id}/users/${user_id}/invitation`),
};
